import { Controller, FieldPath, FieldValues, useFormContext } from 'react-hook-form';
import { SimpleChipsInput, SimpleChipsInputProps } from './SimpleChipsInput';

export type ChipsFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<SimpleChipsInputProps, 'value' | 'onChange'> & {
  name: TName;
  label?: string;
};

export function ChipsField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, ...rest }: ChipsFieldProps<TFieldValues, TName>): JSX.Element {
  const { control } = useFormContext<TFieldValues>();
  const inputId = `chips-field-${name}`;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <SimpleChipsInput
          {...rest}
          value={field.value || []}
          onChange={(event, value) => {
            field.onChange(value);
          }}
          error={!!fieldState.error?.message}
          helperText={fieldState.error?.message ?? rest.helperText}
          disabled={rest.disabled}
        />
      )}
    />
  );
}
